
import React from 'react';
import { useSettings } from '../SettingsContext';

const BillingTaxation: React.FC<{ onSave: () => void }> = ({ onSave }) => {
  const { settings, updateSettings } = useSettings();

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
         <div className="w-10 h-10 bg-indigo-600 rounded-2xl flex items-center justify-center text-white shadow-lg">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><rect width="18" height="18" x="3" y="3" rx="2"/><path d="M3 9h18"/><path d="M9 21V9"/></svg>
         </div>
         <h2 className="text-2xl font-black text-slate-900 uppercase tracking-tight">Billing & Taxation</h2>
      </div>
      
      <div className="bg-white rounded-3xl border border-slate-200 shadow-sm p-8">
        <div className="flex items-center justify-between p-6 bg-slate-50 rounded-2xl border border-slate-100 mb-8">
          <div>
            <p className="text-lg font-black text-slate-900">India GST Compliance</p>
            <p className="text-xs text-slate-500 font-bold uppercase tracking-widest">Automated GSTR Reporting</p>
          </div>
          <button 
            type="button" 
            onClick={() => {
              updateSettings({ isGstEnabled: !settings.isGstEnabled });
              onSave();
            }}
            className={`w-16 h-8 rounded-full relative p-1 transition-all ${settings.isGstEnabled ? 'bg-indigo-600' : 'bg-slate-300'}`}
          >
            <div className={`w-6 h-6 bg-white rounded-full shadow-md transition-transform ${settings.isGstEnabled ? 'translate-x-8' : 'translate-x-0'}`}></div>
          </button>
        </div>

        {settings.isGstEnabled && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 animate-in slide-in-from-top-4 mb-8">
            <div className="space-y-3">
              <label className="text-[10px] font-black text-slate-400 uppercase tracking-[0.2em]">Business GSTIN</label>
              <input 
                type="text" 
                value={settings.businessGstin}
                onChange={(e) => updateSettings({ businessGstin: e.target.value.toUpperCase() })}
                onBlur={onSave}
                className="w-full px-6 py-4 bg-slate-50 border border-slate-200 rounded-2xl font-mono font-black text-sm outline-none focus:ring-4 focus:ring-indigo-50 transition-all" 
              />
            </div>
            <div className="space-y-3">
              <label className="text-[10px] font-black text-slate-400 uppercase tracking-[0.2em]">Tax Rate (%)</label>
              <input 
                type="number" 
                value={settings.gstRate}
                onChange={(e) => updateSettings({ gstRate: parseFloat(e.target.value) || 0 })}
                onBlur={onSave}
                className="w-full px-6 py-4 bg-slate-50 border border-slate-200 rounded-2xl font-black text-sm outline-none focus:ring-4 focus:ring-indigo-50 transition-all" 
              />
            </div>
          </div>
        )}

        <div className="pt-6 border-t border-slate-100 space-y-4">
          <div>
            <h3 className="text-sm font-black text-slate-900 uppercase">Billing Cycle Discounts</h3>
            <p className="text-xs text-slate-500 font-medium mt-0.5">Customize automatic discounts applied when customers select quarterly or annual billing. Set to 0% for no discount.</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-2">
              <label className="text-[10px] font-black text-slate-400 uppercase tracking-[0.2em]">Quarterly Discount (%)</label>
              <input
                type="number"
                min="0"
                max="100"
                value={settings.checkoutConfig?.quarterlyDiscountPercentage ?? 0}
                onChange={(e) => updateSettings({
                  checkoutConfig: {
                    ...settings.checkoutConfig,
                    quarterlyDiscountPercentage: Math.max(0, Math.min(100, parseFloat(e.target.value) || 0))
                  }
                })}
                onBlur={onSave}
                className="w-full px-6 py-4 bg-slate-50 border border-slate-200 rounded-2xl font-black text-sm outline-none focus:ring-4 focus:ring-indigo-50 transition-all"
              />
            </div>
            <div className="space-y-2">
              <label className="text-[10px] font-black text-slate-400 uppercase tracking-[0.2em]">Annual / Yearly Discount (%)</label>
              <input
                type="number"
                min="0"
                max="100"
                value={settings.checkoutConfig?.yearlyDiscountPercentage ?? 0}
                onChange={(e) => updateSettings({
                  checkoutConfig: {
                    ...settings.checkoutConfig,
                    yearlyDiscountPercentage: Math.max(0, Math.min(100, parseFloat(e.target.value) || 0))
                  }
                })}
                onBlur={onSave}
                className="w-full px-6 py-4 bg-slate-50 border border-slate-200 rounded-2xl font-black text-sm outline-none focus:ring-4 focus:ring-indigo-50 transition-all"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BillingTaxation;
